import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';


@Component({
  selector: 'app-field-template',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
  template: `
    @if (templateRef(); as tpl) {
      <ng-container *ngTemplateOutlet="tpl; context: { $implicit: control }" />
    }
  `
})
export class TemplateFieldComponent {
  readonly config = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);

  readonly templateRef = computed(() => this.config.template?.() ?? null);
}
